import { Card, CardContent } from "../../../../shared/components/card/Card";
import { Separator } from "../../../../shared/components/separator/Separator";
import { Button } from "../../../../shared/components/button/Button";
import ActiveBadge from "../../../../shared/components/badge/ActiveBadge";
import TableDeleteButton from "../../../../shared/components/button/TableDeleteButton";

const UserInfoPanel = ({ user, onDeletion, onEdit }) => {
  const DataLabel = ({ data, label }) => (
    <div className="flex flex-row gap-x-2 my-1 px-20">
      <div className="w-1/2 font-bold ml-2">{label}</div>
      <div className="w-1/4">{data}</div>
    </div>
  );

  return (
    <Card className="w-1/2 sm:col-span-2" x-chunk="dashboard-05-chunk-0">
      <CardContent className="pb-3 pt-3 flex flex-row gap-x-10">
        <div className="w-full">
          <div className="flex flex-row">
            <div className="w-1/2 text-xl font-bold text-end">
              {user?.fullname}
            </div>
            <div className="w-1/2 flex flex-row justify-end gap-x-1">
              <Button
                className="h-7 gap-1"
                onClick={() => alert("Funcionalidad pendiente")}
              >
                Editar
              </Button>
              <TableDeleteButton onClickHandler={onDeletion} />
            </div>
          </div>
          <Separator className="my-2" />
          <DataLabel data={user?.username} label="Nombre de usuario" />
          <DataLabel data={user?.email} label="Correo electrónico" />
          <DataLabel
            data={<ActiveBadge booleanValue={user?.enabled} />}
            label="Activo"
          />
          <DataLabel
            data={<ActiveBadge booleanValue={user?.locked} />}
            label="Bloqueado"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default UserInfoPanel;
